/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ManualUsageEvent } from '../models/manual-usage-event';
import { AcceptedResponseBody } from '../models/accepted-response-body';
@Injectable({
  providedIn: 'root',
})
class ManualUsageEventService extends __BaseService {
  static readonly GetManualUsageEventByIdPath = '/manualusageevent';
  static readonly UpdateManualUsageEventPath = '/manualusageevent';
  static readonly CreateManualUsageEventPath = '/manualusageevent';
  static readonly GetAllManualUsageEventsPath = '/manualusageevent/GetAllManualUsageEvents';
  static readonly DeleteManualUsageEventPath = '/manualusageevent/{id}';
  static readonly GetTemplatePath = '/manualusageevent/template';
  static readonly PostTemplatePath = '/manualusageevent/template';
  static readonly GetAccrualPath = '/manualusageevent/accrual';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `ManualUsageEventService.GetManualUsageEventByIdParams` containing the following parameters:
   *
   * - `manualUsageEventId`:
   *
   * - `Authorization`: Bearer token
   *
   * @return Success
   */
  GetManualUsageEventByIdResponse(params: ManualUsageEventService.GetManualUsageEventByIdParams): __Observable<__StrictHttpResponse<ManualUsageEvent>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.manualUsageEventId != null) __params = __params.set('manualUsageEventId', params.manualUsageEventId.toString());
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/manualusageevent`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ManualUsageEvent>;
      })
    );
  }
  /**
   * @param params The `ManualUsageEventService.GetManualUsageEventByIdParams` containing the following parameters:
   *
   * - `manualUsageEventId`:
   *
   * - `Authorization`: Bearer token
   *
   * @return Success
   */
  GetManualUsageEventById(params: ManualUsageEventService.GetManualUsageEventByIdParams): __Observable<ManualUsageEvent> {
    return this.GetManualUsageEventByIdResponse(params).pipe(
      __map(_r => _r.body as ManualUsageEvent)
    );
  }

  /**
   * @param params The `ManualUsageEventService.UpdateManualUsageEventParams` containing the following parameters:
   *
   * - `zip`:
   *
   * - `year`:
   *
   * - `value`:
   *
   * - `utilityName`:
   *
   * - `storeNumber`:
   *
   * - `state`:
   *
   * - `siteName`:
   *
   * - `serviceDescription`:
   *
   * - `requester`:
   *
   * - `product`:
   *
   * - `primaryService`:
   *
   * - `month`:
   *
   * - `meterNumber`:
   *
   * - `manualUsageEventType`:
   *
   * - `manualUsageEventId`:
   *
   * - `description`:
   *
   * - `daysToBill`:
   *
   * - `dateRequested`:
   *
   * - `dataLineageId`:
   *
   * - `consolidationInvoiceNumber`:
   *
   * - `consolidationID`:
   *
   * - `consolidationFunded`:
   *
   * - `clientName`:
   *
   * - `city`:
   *
   * - `category`:
   *
   * - `billConsolidatedOn`:
   *
   * - `aviClientId`:
   *
   * - `address`:
   *
   * - `accountNumber`:
   *
   * - `Authorization`: Bearer token
   *
   * @return Success
   */
  UpdateManualUsageEventResponse(params: ManualUsageEventService.UpdateManualUsageEventParams): __Observable<__StrictHttpResponse<AcceptedResponseBody>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.zip != null) __params = __params.set('zip', params.zip.toString());
    if (params.year != null) __params = __params.set('year', params.year.toString());
    if (params.value != null) __params = __params.set('value', params.value.toString());
    if (params.utilityName != null) __params = __params.set('utilityName', params.utilityName.toString());
    if (params.storeNumber != null) __params = __params.set('storeNumber', params.storeNumber.toString());
    if (params.state != null) __params = __params.set('state', params.state.toString());
    if (params.siteName != null) __params = __params.set('siteName', params.siteName.toString());
    if (params.serviceDescription != null) __params = __params.set('serviceDescription', params.serviceDescription.toString());
    if (params.requester != null) __params = __params.set('requester', params.requester.toString());
    if (params.product != null) __params = __params.set('product', params.product.toString());
    if (params.primaryService != null) __params = __params.set('primaryService', params.primaryService.toString());
    if (params.month != null) __params = __params.set('month', params.month.toString());
    if (params.meterNumber != null) __params = __params.set('meterNumber', params.meterNumber.toString());
    if (params.manualUsageEventType != null) __params = __params.set('manualUsageEventType', params.manualUsageEventType.toString());
    if (params.manualUsageEventId != null) __params = __params.set('manualUsageEventId', params.manualUsageEventId.toString());
    if (params.description != null) __params = __params.set('description', params.description.toString());
    if (params.daysToBill != null) __params = __params.set('daysToBill', params.daysToBill.toString());
    if (params.dateRequested != null) __params = __params.set('dateRequested', params.dateRequested.toString());
    if (params.dataLineageId != null) __params = __params.set('dataLineageId', params.dataLineageId.toString());
    if (params.consolidationInvoiceNumber != null) __params = __params.set('consolidationInvoiceNumber', params.consolidationInvoiceNumber.toString());
    if (params.consolidationID != null) __params = __params.set('consolidationID', params.consolidationID.toString());
    if (params.consolidationFunded != null) __params = __params.set('consolidationFunded', params.consolidationFunded.toString());
    if (params.clientName != null) __params = __params.set('clientName', params.clientName.toString());
    if (params.city != null) __params = __params.set('city', params.city.toString());
    if (params.category != null) __params = __params.set('category', params.category.toString());
    if (params.billConsolidatedOn != null) __params = __params.set('billConsolidatedOn', params.billConsolidatedOn.toString());
    if (params.aviClientId != null) __params = __params.set('aviClientId', params.aviClientId.toString());
    if (params.address != null) __params = __params.set('address', params.address.toString());
    if (params.accountNumber != null) __params = __params.set('accountNumber', params.accountNumber.toString());
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/manualusageevent`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AcceptedResponseBody>;
      })
    );
  }
  /**
   * @param params The `ManualUsageEventService.UpdateManualUsageEventParams` containing the following parameters:
   *
   * - `zip`:
   *
   * - `year`:
   *
   * - `value`:
   *
   * - `utilityName`:
   *
   * - `storeNumber`:
   *
   * - `state`:
   *
   * - `siteName`:
   *
   * - `serviceDescription`:
   *
   * - `requester`:
   *
   * - `product`:
   *
   * - `primaryService`:
   *
   * - `month`:
   *
   * - `meterNumber`:
   *
   * - `manualUsageEventType`:
   *
   * - `manualUsageEventId`:
   *
   * - `description`:
   *
   * - `daysToBill`:
   *
   * - `dateRequested`:
   *
   * - `dataLineageId`:
   *
   * - `consolidationInvoiceNumber`:
   *
   * - `consolidationID`:
   *
   * - `consolidationFunded`:
   *
   * - `clientName`:
   *
   * - `city`:
   *
   * - `category`:
   *
   * - `billConsolidatedOn`:
   *
   * - `aviClientId`:
   *
   * - `address`:
   *
   * - `accountNumber`:
   *
   * - `Authorization`: Bearer token
   *
   * @return Success
   */
  UpdateManualUsageEvent(params: ManualUsageEventService.UpdateManualUsageEventParams): __Observable<ManualUsageEvent> {
    return this.UpdateManualUsageEventResponse(params).pipe(
      __map(_r => _r.body as ManualUsageEvent)
    );
  }

  /**
   * @param params The `ManualUsageEventService.CreateManualUsageEventParams` containing the following parameters:
   *
   * - `zip`:
   *
   * - `year`:
   *
   * - `value`:
   *
   * - `utilityName`:
   *
   * - `storeNumber`:
   *
   * - `state`:
   *
   * - `siteName`:
   *
   * - `serviceDescription`:
   *
   * - `requester`:
   *
   * - `product`:
   *
   * - `primaryService`:
   *
   * - `month`:
   *
   * - `meterNumber`:
   *
   * - `manualUsageEventType`:
   *
   * - `manualUsageEventId`:
   *
   * - `description`:
   *
   * - `daysToBill`:
   *
   * - `dateRequested`:
   *
   * - `dataLineageId`:
   *
   * - `consolidationInvoiceNumber`:
   *
   * - `consolidationID`:
   *
   * - `consolidationFunded`:
   *
   * - `clientName`:
   *
   * - `city`:
   *
   * - `category`:
   *
   * - `billConsolidatedOn`:
   *
   * - `aviClientId`:
   *
   * - `address`:
   *
   * - `accountNumber`:
   *
   * - `Authorization`: Bearer token
   *
   * @return Success
   */
  CreateManualUsageEventResponse(params: ManualUsageEventService.CreateManualUsageEventParams): __Observable<__StrictHttpResponse<ManualUsageEvent>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.zip != null) __params = __params.set('zip', params.zip.toString());
    if (params.year != null) __params = __params.set('year', params.year.toString());
    if (params.value != null) __params = __params.set('value', params.value.toString());
    if (params.utilityName != null) __params = __params.set('utilityName', params.utilityName.toString());
    if (params.storeNumber != null) __params = __params.set('storeNumber', params.storeNumber.toString());
    if (params.state != null) __params = __params.set('state', params.state.toString());
    if (params.siteName != null) __params = __params.set('siteName', params.siteName.toString());
    if (params.serviceDescription != null) __params = __params.set('serviceDescription', params.serviceDescription.toString());
    if (params.requester != null) __params = __params.set('requester', params.requester.toString());
    if (params.product != null) __params = __params.set('product', params.product.toString());
    if (params.primaryService != null) __params = __params.set('primaryService', params.primaryService.toString());
    if (params.month != null) __params = __params.set('month', params.month.toString());
    if (params.meterNumber != null) __params = __params.set('meterNumber', params.meterNumber.toString());
    if (params.manualUsageEventType != null) __params = __params.set('manualUsageEventType', params.manualUsageEventType.toString());
    if (params.manualUsageEventId != null) __params = __params.set('manualUsageEventId', params.manualUsageEventId.toString());
    if (params.description != null) __params = __params.set('description', params.description.toString());
    if (params.daysToBill != null) __params = __params.set('daysToBill', params.daysToBill.toString());
    if (params.dateRequested != null) __params = __params.set('dateRequested', params.dateRequested.toString());
    if (params.dataLineageId != null) __params = __params.set('dataLineageId', params.dataLineageId.toString());
    if (params.consolidationInvoiceNumber != null) __params = __params.set('consolidationInvoiceNumber', params.consolidationInvoiceNumber.toString());
    if (params.consolidationID != null) __params = __params.set('consolidationID', params.consolidationID.toString());
    if (params.consolidationFunded != null) __params = __params.set('consolidationFunded', params.consolidationFunded.toString());
    if (params.clientName != null) __params = __params.set('clientName', params.clientName.toString());
    if (params.city != null) __params = __params.set('city', params.city.toString());
    if (params.category != null) __params = __params.set('category', params.category.toString());
    if (params.billConsolidatedOn != null) __params = __params.set('billConsolidatedOn', params.billConsolidatedOn.toString());
    if (params.aviClientId != null) __params = __params.set('aviClientId', params.aviClientId.toString());
    if (params.address != null) __params = __params.set('address', params.address.toString());
    if (params.accountNumber != null) __params = __params.set('accountNumber', params.accountNumber.toString());
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/manualusageevent`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ManualUsageEvent>;
      })
    );
  }
  /**
   * @param params The `ManualUsageEventService.CreateManualUsageEventParams` containing the following parameters:
   *
   * - `zip`:
   *
   * - `year`:
   *
   * - `value`:
   *
   * - `utilityName`:
   *
   * - `storeNumber`:
   *
   * - `state`:
   *
   * - `siteName`:
   *
   * - `serviceDescription`:
   *
   * - `requester`:
   *
   * - `product`:
   *
   * - `primaryService`:
   *
   * - `month`:
   *
   * - `meterNumber`:
   *
   * - `manualUsageEventType`:
   *
   * - `manualUsageEventId`:
   *
   * - `description`:
   *
   * - `daysToBill`:
   *
   * - `dateRequested`:
   *
   * - `dataLineageId`:
   *
   * - `consolidationInvoiceNumber`:
   *
   * - `consolidationID`:
   *
   * - `consolidationFunded`:
   *
   * - `clientName`:
   *
   * - `city`:
   *
   * - `category`:
   *
   * - `billConsolidatedOn`:
   *
   * - `aviClientId`:
   *
   * - `address`:
   *
   * - `accountNumber`:
   *
   * - `Authorization`: Bearer token
   *
   * @return Success
   */
  CreateManualUsageEvent(params: ManualUsageEventService.CreateManualUsageEventParams): __Observable<ManualUsageEvent> {
    return this.CreateManualUsageEventResponse(params).pipe(
      __map(_r => _r.body as ManualUsageEvent)
    );
  }

  /**
   * @param params The `ManualUsageEventService.GetAllManualUsageEventsParams` containing the following parameters:
   *
   * - `year`:
   *
   * - `month`:
   *
   * - `clientId`:
   *
   * - `Authorization`: Bearer token
   *
   * @return Success
   */
  GetAllManualUsageEventsResponse(params: ManualUsageEventService.GetAllManualUsageEventsParams): __Observable<__StrictHttpResponse<Array<ManualUsageEvent>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.year != null) __params = __params.set('year', params.year.toString());
    if (params.month != null) __params = __params.set('month', params.month.toString());
    if (params.clientId != null) __params = __params.set('clientId', params.clientId.toString());
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/manualusageevent/GetAllManualUsageEvents`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ManualUsageEvent>>;
      })
    );
  }
  /**
   * @param params The `ManualUsageEventService.GetAllManualUsageEventsParams` containing the following parameters:
   *
   * - `year`:
   *
   * - `month`:
   *
   * - `clientId`:
   *
   * - `Authorization`: Bearer token
   *
   * @return Success
   */
  GetAllManualUsageEvents(params: ManualUsageEventService.GetAllManualUsageEventsParams): __Observable<Array<ManualUsageEvent>> {
    return this.GetAllManualUsageEventsResponse(params).pipe(
      __map(_r => _r.body as Array<ManualUsageEvent>)
    );
  }

  /**
   * @param params The `ManualUsageEventService.DeleteManualUsageEventParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `Authorization`: Bearer token
   */
  DeleteManualUsageEventResponse(params: ManualUsageEventService.DeleteManualUsageEventParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/manualusageevent/${params.id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param params The `ManualUsageEventService.DeleteManualUsageEventParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `Authorization`: Bearer token
   */
  DeleteManualUsageEvent(params: ManualUsageEventService.DeleteManualUsageEventParams): __Observable<null> {
    return this.DeleteManualUsageEventResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param Authorization Bearer token
   */
  GetTemplateResponse(Authorization?: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (Authorization != null) __headers = __headers.set('Authorization', Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/manualusageevent/template`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param Authorization Bearer token
   */
  GetTemplate(Authorization?: string): __Observable<null> {
    return this.GetTemplateResponse(Authorization).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param params The `ManualUsageEventService.PostTemplateParams` containing the following parameters:
   *
   * - `file`:
   *
   * - `Authorization`: Bearer token
   */
  PostTemplateResponse(params: ManualUsageEventService.PostTemplateParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __headers.append('Content-Type', 'multipart/form-data');
    let __formData = new FormData();
    __body = __formData;
   if(params.file !== null && typeof params.file !== "undefined") { __formData.append('file', params.file as string | Blob);}
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/manualusageevent/template`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param params The `ManualUsageEventService.PostTemplateParams` containing the following parameters:
   *
   * - `file`:
   *
   * - `Authorization`: Bearer token
   */
  PostTemplate(params: ManualUsageEventService.PostTemplateParams): __Observable<null> {
    return this.PostTemplateResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param Authorization Bearer token
   */
  GetAccrualResponse(Authorization?: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (Authorization != null) __headers = __headers.set('Authorization', Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/manualusageevent/accrual`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param Authorization Bearer token
   */
  GetAccrual(Authorization?: string): __Observable<null> {
    return this.GetAccrualResponse(Authorization).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module ManualUsageEventService {

  /**
   * Parameters for GetManualUsageEventById
   */
  export interface GetManualUsageEventByIdParams {
    manualUsageEventId?: string;

    /**
     * Bearer token
     */
    Authorization?: string;
  }

  /**
   * Parameters for UpdateManualUsageEvent
   */
  export interface UpdateManualUsageEventParams {
    zip?: string;
    year?: number;
    value?: number;
    utilityName?: string;
    storeNumber?: string;
    state?: string;
    siteName?: string;
    serviceDescription?: string;
    requester?: string;
    product?: string;
    primaryService?: string;
    month?: number;
    meterNumber?: string;
    manualUsageEventType?: 'Base' | 'OpenClose' | 'LateUtilityFeeAdjustment' | 'LateFunding';
    manualUsageEventId?: string;
    description?: string;
    daysToBill?: number;
    dateRequested?: string;
    dataLineageId?: string;
    consolidationInvoiceNumber?: string;
    consolidationID?: string;
    consolidationFunded?: string;
    clientName?: string;
    city?: string;
    category?: string;
    billConsolidatedOn?: string;
    aviClientId?: string;
    address?: string;
    accountNumber?: string;

    /**
     * Bearer token
     */
    Authorization?: string;
  }

  /**
   * Parameters for CreateManualUsageEvent
   */
  export interface CreateManualUsageEventParams {
    zip?: string;
    year?: number;
    value?: number;
    utilityName?: string;
    storeNumber?: string;
    state?: string;
    siteName?: string;
    serviceDescription?: string;
    requester?: string;
    product?: string;
    primaryService?: string;
    month?: number;
    meterNumber?: string;
    manualUsageEventType?: 'Base' | 'OpenClose' | 'LateUtilityFeeAdjustment' | 'LateFunding';
    manualUsageEventId?: string;
    description?: string;
    daysToBill?: number;
    dateRequested?: string;
    dataLineageId?: string;
    consolidationInvoiceNumber?: string;
    consolidationID?: string;
    consolidationFunded?: string;
    clientName?: string;
    city?: string;
    category?: string;
    billConsolidatedOn?: string;
    aviClientId?: string;
    address?: string;
    accountNumber?: string;

    /**
     * Bearer token
     */
    Authorization?: string;
  }

  /**
   * Parameters for GetAllManualUsageEvents
   */
  export interface GetAllManualUsageEventsParams {
    year?: number;
    month?: number;
    clientId?: string;

    /**
     * Bearer token
     */
    Authorization?: string;
  }

  /**
   * Parameters for DeleteManualUsageEvent
   */
  export interface DeleteManualUsageEventParams {
    id: string;

    /**
     * Bearer token
     */
    Authorization?: string;
  }

  /**
   * Parameters for PostTemplate
   */
  export interface PostTemplateParams {
    file?: Blob;

    /**
     * Bearer token
     */
    Authorization?: string;
  }
}

export { ManualUsageEventService }
